__turbopack_context__.v({
  "container": "enrolled-box-module-scss-module__YCNreq__container",
  "cta-container": "enrolled-box-module-scss-module__YCNreq__cta-container",
  "enrolled-message": "enrolled-box-module-scss-module__YCNreq__enrolled-message",
  "enrolled-message-container": "enrolled-box-module-scss-module__YCNreq__enrolled-message-container",
  "money-back-guarantee-container": "enrolled-box-module-scss-module__YCNreq__money-back-guarantee-container",
});
